import styled from 'styled-components';
import {
  Input as SemanticInput,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Loader as LoaderComponent } from '@playbookux/playbook-web-core';

const Loader = styled(LoaderComponent)``;

const Button = styled(ButtonLayoutComponent)`
  width: 90%;
`;

const Input = styled(SemanticInput)`
  width: 90%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  width: 300px;
  text-align: center;
`;

const ContainerText = styled.div`
  margin-top: 10px;
  font-size: 17px;
  color: #4D5473;
`;

const ErrorMessage = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 17px;
  color: #9F3A38;
`;

const LockerIcon = styled.img`
  max-width: 100px;
`;

export {
  Button,
  Input,
  Container,
  ContainerText,
  Content,
  LockerIcon,
  ErrorMessage,
  Loader,
};
